import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'recall-dialog',
    styleUrl: 'recall-dialog.component.scss',
    templateUrl: 'recall-dialog.component.html',
    standalone: false
})
export class RecallDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<RecallDialogComponent, 'yes'>
    ) { }

    onYesClick(): void {
        this.dialogRef.close('yes');
    }
}
